import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => createStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkbox: {
    color: '#01B3C5 !important',
    padding: '3px 3px 3px 8px',
  },
  label: {
    fontSize: 14,
  },
}));

export default useStyles;
